// extracted by mini-css-extract-plugin
export default {"container":"vgD4XV","title":"Fac8Qz","subtitle":"RCbkWX","mobile-break":"vkZbYU","mobileBreak":"vkZbYU"};